import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import Select from 'ati-ui-react/components/AtiSelect';
import setUrlParam from 'utils/setUrlParam';

import tariffTypes from './tariffTypes';

import { PeriodTypesContainer } from './PeriodTypesStyles';

const defaultValue = {
  label: 'в день',
  value: 'day',
};

const PeriodTypes: FC = observer(() => {
  const {
    findTrucksStore: {
      fields: { period_type },
      updateSelect,
    },
  } = useStores();

  return (
    <PeriodTypesContainer>
      <Select
        className="period-types"
        value={period_type || defaultValue}
        options={tariffTypes}
        onChange={(value: { value: string }) => {
          updateSelect({ field: 'period_type', value: value?.value });
          setUrlParam({ field: 'period_type', value: value?.value });
        }}
        clearable={false}
        searchable={false}
      />
    </PeriodTypesContainer>
  );
});

export default PeriodTypes;
